import {
  isStaffOrImpersonated,
  type StaffFeatures,
} from "@/state-standards/isStaffOrImpersonated";

interface GetCanAccessStandardsAlignmentReportArgs {
  features?: StaffFeatures | undefined;
  /** Untyped on the server, `string | object | undefined` on the client. */
  experimentSegment?: unknown;
}

/**
 * Single source of truth for who may see the Standards Alignment Report: staff and
 * impersonated sessions keep the access they already had, everyone else needs the
 * `standards_alignment_report` experiment. Stays free of client-only imports so
 * `getServerSideProps` can use it.
 */
export const getCanAccessStandardsAlignmentReport = ({
  features,
  experimentSegment,
}: GetCanAccessStandardsAlignmentReportArgs): boolean =>
  isStaffOrImpersonated(features) || experimentSegment === "on";
